import { Draft, produce } from 'immer';

import * as TYPES from '@app/store/actionTypes';
import {
  scheduledDocumentPreviewDataFetched,
  setupTemplateByDraft,
  TemplateAction,
} from '@app/store/template/actions';

export interface TemplateFieldIdsInPagesState {
  [page: string]: string[];
}

const initialState: TemplateFieldIdsInPagesState = {};
// TODO(@DevSDK): 추후 사용하지 않는 상태인지 확인할때 살펴보기
const reducer = produce((draft: Draft<TemplateFieldIdsInPagesState>, action: TemplateAction) => {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_REQUEST:
      return initialState;
    case scheduledDocumentPreviewDataFetched.type:
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS: {
      const { participants } = action.payload;
      participants.forEach((participant) => {
        const { fields } = participant;
        const { signatureFields, textFields, checkboxGroups } = fields;

        checkboxGroups.forEach((checkboxGroup) => {
          if (!(checkboxGroup.page in draft)) {
            draft[checkboxGroup.page] = [];
          }
          draft[checkboxGroup.page].push(checkboxGroup.id);
          checkboxGroup.children.forEach((checkboxField) => {
            if (!(checkboxField.page in draft)) {
              draft[checkboxField.page] = [];
            }
            draft[checkboxField.page].push(checkboxField.id);
          });
        });

        signatureFields.forEach((signatureField) => {
          if (!(signatureField.page in draft)) {
            draft[signatureField.page] = [];
          }
          draft[signatureField.page].push(signatureField.id);
        });
        textFields.forEach((textField) => {
          if (!(textField.page in draft)) {
            draft[textField.page] = [];
          }
          draft[textField.page].push(textField.id);
        });
      });
      return draft;
    }
    case setupTemplateByDraft.type: {
      action.payload.participants.forEach((participant) => {
        participant.fields.forEach((field) => {
          if (!draft[field.position.page]) {
            draft[field.position.page] = [];
          }

          draft[field.position.page].push(field.id);
        });
      });

      return draft;
    }
    case TYPES.TEMPLATE_FIELD_CREATE: {
      const { id, page } = action.payload.meta;
      if (!(page in draft)) {
        draft[page] = [id];
      } else {
        draft[page].push(id);
      }
      return draft;
    }
    case TYPES.TEMPLATE_FIELD_DELETE: {
      const { id, page } = action.payload;
      const index = draft[page].findIndex((v) => v === id);
      if (index !== -1) {
        draft[page].splice(index, 1);
      }
      return draft;
    }
    case TYPES.TEMPLATE__FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE: {
      const { pages } = action.payload;

      pages.forEach((page) => {
        if (page in draft) {
          delete draft[page];
        }
      });

      return draft;
    }
    case TYPES.TEMPLATE_PARTICIPANT_DELETE: {
      const { fieldIds } = action.payload;
      Object.keys(draft).forEach((key) => {
        const idsInPage = draft[key];
        draft[key] = idsInPage.filter((id) => !fieldIds.includes(id));
      });
      return draft;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
